/**
 * DevExtreme (esm/__internal/grids/data_grid/grouping/const.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export const CLASSES = {
  groupPanel: "dx-datagrid-group-panel",
  groupPanelMessage: "dx-group-panel-message",
  groupPanelItem: "dx-group-panel-item",
  groupPanelLabel: "dx-toolbar-label",
  groupPanelContainer: "dx-toolbar-item"
};
export const CONTEXT_MENU_GROUP_BY_COLUMN_ICON_NAME = "groupbycolumn";
export const CONTEXT_MENU_UNGROUP_COLUMN_ICON_NAME = "ungroupcolumn";
export const CONTEXT_MENU_UNGROUP_ALL_COLUMNS_ICON_NAME = "ungroupallcolumns";